require=(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({"8-script-cus":[function(require,module,exports){
cc._RFpush(module, 'acdbf2bI0JOXYZMrv8FzomK', '8-script-cus');
// cus-on-emit\8-script-cus.js

'use strict';

cc.Class({
    'extends': cc.Component,

    properties: {
        fore: { //每个人都监听来自前一个人的消息
            'default': null,
            type: cc.Node
        }
    },

    // use this for initialization
    onLoad: function onLoad() {
        //自定义事件
        //自定义事件和系统事件不同的是
        //需要在代码中手动触发
        //其他的和系统事件没有区别
        //node.emit('eventName',message);
        //node.on('eventName',callBack,target);
        //callBack(event){
        //      (event.detail === message) //true!   
        //}

        if (this.fore) //如果有前一个人
            this.fore.on('hello!', this.doAction, this); //我们就监听来自前一个人的消息

        this.node.on('mouseup', function () {
            //如果我们被点击
            this.node.emit('hello!', this.node.name); //就向身后一个人发消息,消息为自己的名字
            this.node.getChildByName('msg').getComponent(cc.Label).string = 'hello!~~'; //和身后的伙伴们打声招呼吧~
        }, this);
    },

    doAction: function doAction(event) {
        //收到消息了哦
        var action1 = cc.scaleTo(0.1, -1, 0).easing(cc.easeBackOut());
        var action2 = cc.rotateBy(0.1, 360).easing(cc.easeBackOut());
        var action12 = cc.spawn(action1, action2); //一起摇摆~

        var callNext = cc.callFunc(this.callNext, this, event); //向身后一个人继续发消息哦

        var action3 = cc.scaleTo(0.1, 1, 1).easing(cc.easeBackOut());
        var action4 = cc.rotateBy(0.1, -360).easing(cc.easeBackOut());
        var action34 = cc.spawn(action3, action4); //一起摇摆~

        this.node.runAction(cc.sequence(action12, callNext, action34));
    },

    callNext: function callNext(myCaller, event) {
        this.node.emit('hello!', event.detail); //我们要保持消息的一致 一开始的名字被存在event.detail中了
        this.node.getChildByName('msg').getComponent(cc.Label).string = 'hello! ' + event.detail; //和一开始的伙伴打声招呼吧~
    }

    // called every frame, uncomment this function to activate update callback
    // update: function (dt) {

    // },
});

cc._RFpop();
},{}],"A-script-easing":[function(require,module,exports){
cc._RFpush(module, 'f6400u1oCpL24WgaPBYpBr5', 'A-script-easing');
// easing-action\A-script-easing.js

'use strict';

cc.Class({
    'extends': cc.Component,

    properties: {},

    onLoad: function onLoad() {
        //注: 以下的东西我也说不出是什么=.=
    },

    'on-1cardinalSplineTo': function on1cardinalSplineTo() {
        //cardinalSplineTo(duration,points,tesion)
        //duration Number
        //points   Array   array of control points
        //tension  Number
        var point1 = cc.v2(0, 100);
        var point2 = cc.v2(300, 200);
        var point3 = cc.v2(50, 400);

        var action = cc.cardinalSplineTo(3, [point1, point2, point3], 0);

        this.node.runAction(action);
    },

    'on-2cardinalSplineBy': function on2cardinalSplineBy() {
        //cardinalSplineBy(duration,points,tesion)
        //duration Number
        //points   Array   array of control points
        //tension  Number
        var point1 = cc.v2(0, 100);
        var point2 = cc.v2(300, 200);
        var point3 = cc.v2(50, 400);

        var action = cc.cardinalSplineBy(3, [point1, point2, point3], 0);

        this.node.runAction(action);
    },

    'on-3catmullRomTo': function on3catmullRomTo() {
        //catmullRomTo(duration,points,tesion)
        //dt Number
        //points   Array   array of control points
        //tension  Number
        var point1 = cc.v2(0, 100);
        var point2 = cc.v2(300, 200);
        var point3 = cc.v2(50, 400);

        var action = cc.catmullRomTo(3, [point1, point2, point3]);

        this.node.runAction(action);
    },

    'on-4catmullRomBy': function on4catmullRomBy() {
        //catmullRomBy(duration,points,tesion)
        //dt Number
        //points   Array   array of control points
        //tension  Number
        var point1 = cc.v2(0, 100);
        var point2 = cc.v2(300, 200);
        var point3 = cc.v2(50, 400);

        var action = cc.catmullRomBy(3, [point1, point2, point3]);

        this.node.runAction(action);
    },

    'on-5easeIn': function on5easeIn() {
        //easeIn(rate)
        //rate     Number
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeIn(3.0)));
    },

    'on-6easeOut': function on6easeOut() {
        //easeOut(rate) 
        //rate     Number
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeOut(3.0)));
    },

    'on-7easeInOut': function on7easeInOut() {
        //easeInOut(rate) 
        //rate     Number
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeInOut(3.0)));
    },

    'on-8easeExponentialIn': function on8easeExponentialIn() {
        //easeExponentialIn() 
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeExponentialIn()));
    },

    'on-9easeExponentialOut': function on9easeExponentialOut() {
        //easeExponentialOut() 
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeExponentialOut()));
    },

    'on-10easeExponentialInOut': function on10easeExponentialInOut() {
        //easeExponentialInOut() 
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeExponentialInOut()));
    },

    'on-11easeSineIn': function on11easeSineIn() {
        //easeSineIn() 
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeSineIn()));
    },

    'on-12easeSineOut': function on12easeSineOut() {
        //easeSineOut() 
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeSineOut()));
    },

    'on-13easeSineInOut': function on13easeSineInOut() {
        //easeSineInOut() 
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeSineInOut()));
    },

    'on-14easeElasticIn': function on14easeElasticIn() {
        //easeElasticIn([period =0.3]) 
        //period Number 应该是周期什么的
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeElasticIn(3.0)));
    },

    'on-15easeElasticOut': function on15easeElasticOut() {
        //easeElasticOut([period =0.3]) 
        //period Number 应该是周期什么的
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeElasticOut(3.0)));
    },

    'on-16easeElasticInOut': function on16easeElasticInOut() {
        //easeElasticInOut([period =0.3]) 
        //period Number 应该是周期什么的
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeElasticInOut(3.0)));
    },

    'on-17easeBounceIn': function on17easeBounceIn() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeBounceIn()));
    },

    'on-18easeBounceOut': function on18easeBounceOut() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeBounceOut()));
    },

    'on-19easeBounceInOut': function on19easeBounceInOut() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeBounceInOut()));
    },

    'on-20easeBackIn': function on20easeBackIn() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeBackIn()));
    },

    'on-21easeBackOut': function on21easeBackOut() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeBackOut()));
    },

    'on-22easeBackInOut': function on22easeBackInOut() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeBackInOut()));
    },

    'on-23easeBezierAction': function on23easeBezierAction() {
        //Creates the action easing object.
        //Into the 4 reference point.
        //To calculate the motion curve.
        //p0	Number	The first bezier parameter
        //p1	Number	The second bezier parameter
        //p2	Number	The third bezier parameter
        //p3	Number	The fourth bezier parameter

        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeBezierAction(0.5, 0.5, 1.0, 1.0)));
    },

    'on-24easeQuadraticActionIn': function on24easeQuadraticActionIn() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeQuadraticActionIn()));
    },

    'on-25easeQuadraticActionOut': function on25easeQuadraticActionOut() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeQuadraticActionOut()));
    },

    'on-26easeQuadraticActionInOut': function on26easeQuadraticActionInOut() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeQuadraticActionInOut()));
    },

    'on-27easeQuarticActionIn': function on27easeQuarticActionIn() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeQuarticActionIn()));
    },

    'on-28easeQuarticActionOut': function on28easeQuarticActionOut() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeQuarticActionOut()));
    },

    'on-29easeQuarticActionInOut': function on29easeQuarticActionInOut() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeQuarticActionInOut()));
    },

    'on-30easeQuinticActionIn': function on30easeQuinticActionIn() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeQuinticActionIn()));
    },

    'on-31easeQuinticActionOut': function on31easeQuinticActionOut() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeQuinticActionOut()));
    },

    'on-32easeQuinticActionInOut': function on32easeQuinticActionInOut() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeQuinticActionInOut()));
    },

    'on-33easeCircleActionIn': function on33easeCircleActionIn() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeCircleActionIn()));
    },

    'on-34easeCircleActionOut': function on34easeCircleActionOut() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeCircleActionOut()));
    },

    'on-35easeCircleActionInOut': function on35easeCircleActionInOut() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeCircleActionInOut()));
    },

    'on-36easeCubicActionIn': function on36easeCubicActionIn() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeCubicActionIn()));
    },

    'on-37easeCubicActionOut': function on37easeCubicActionOut() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeCubicActionOut()));
    },

    'on-38easeCubicActionInOut': function on38easeCubicActionInOut() {
        var action = cc.rotateBy(1, 180);

        this.node.runAction(action.easing(cc.easeCubicActionInOut()));
    }

});

cc._RFpop();
},{}],"A-script-simple":[function(require,module,exports){
cc._RFpush(module, '87decLk0X5HloARcXLKWgk8', 'A-script-simple');
// simple-action\A-script-simple.js

'use strict';

var A = cc.Class({
    'extends': cc.Component,

    properties: {
        callbacklabel: {
            'default': null,
            type: cc.Label
        }
    },

    onLoad: function onLoad() {},

    'on-show': function onShow() {
        //显示节点
        //cc.show()
        //warn:貌似没有效果
        console.log('on-show');
        this.node.runAction(cc.show());
    },

    'on-hide': function onHide() {
        //隐藏节点
        //cc.Hide()
        //warn:貌似没有效果
        console.log('on-hide');
        this.node.runAction(cc.hide());
    },

    'on-toggleVisibility': function onToggleVisibility() {
        //显示节点和隐藏节点和结合
        //cc.toggleVisibility()
        //warn:貌似没有效果
        console.log('on-toggleVisibility');
        this.node.runAction(cc.toggleVisibility());
    },

    'on-removeSelf': function onRemoveSelf() {
        //移除自身
        //参数一 [isNeedCleanUp = true ] 移除的同时是否清空内存？ 好像是这样吧 默认值为true
        //cc.removeSelf([isNeedCleanUp = true]);
        //this.node.runAction(cc.removeSelf());
    },

    'on-flipX': function onFlipX() {
        //左右立即翻转
        //参数一 flip 如果为true就左翻，false就右翻？ 好像是， 没有默认值。
        //cc.flipX(flip);
        //warn:貌似没有效果
        console.log('on-flipX');
        this.node.runAction(cc.flipX(true));
    },

    'on-flipY': function onFlipY() {
        //上下立即翻转
        //参数一 flip 如果为true就左翻，false就右翻？ 好像是， 没有默认值。
        //cc.flipY(flip);
        //warn:貌似没有效果
        console.log('on-flipY');
        this.node.runAction(cc.flipY(true));
    },

    'on-place': function onPlace() {
        //设置位置
        //参数一 pos cc.Vec2(x,y)类型 表示的位置
        //参数二 [y ] 位置的y值
        //解释 也就是说可以用下面两种方式
        //cc.place(pos, [y ]);
        //this.node.runAction(cc.place(cc.v2(50,50)));
        //this.node.runAction(cc.place(50,50));
        console.log('on-place');
        this.node.runAction(cc.place(0, 0)); //设置当前节点的位置为(0px,0px) 注：父节点锚点(Anchor)的位置为(0px,0px)
    },

    'on-callFunc': function onCallFunc() {
        //回调
        //参数一 selector function类型 表示要执行的函数
        //参数二 [selectorTarget ] 表示执行该函数的对象
        //参数三 [data ]   传递给函数的参数
        //cc.callFunc(selector, [selectorTarget ],[data ]);
        console.log('on-callFunc');
        this.node.runAction(cc.callFunc(this.mycallback, this, { a: 'cocos', b: 'creator' }));
    },

    mycallback: function mycallback(target, data) {
        //这个回调函数会收到两个参数
        //第一个是回调这个函数的组件所在的节点 即this.node
        //第二个是我们传进来的参数对象了{a:'cocos',b:'creator'},
        var AScript = target.getComponent('A-script-simple');
        AScript.callbacklabel.string = data.a + data.b;
    },

    'on-sequence': function onSequence() {
        //序列动画 可以让动画一个接一个地执行
        //参数一 tempArray 需要顺序执行的一组动画
        var action1 = cc.rotateTo(1, 180);
        var action2 = cc.rotateTo(1, 0);
        //可以单独传
        //this.node.runAction(cc.sequence(action1,action2));
        //也可以扔一个数组
        //cc.sequence(tempArray);
        console.log('on-sequence');
        var actionsArray = [action1, action2];
        this.node.runAction(cc.sequence(actionsArray));
    },

    'on-repeat': function onRepeat() {
        //重复动画
        //参数一 action 需要执行的动画
        //参数二 times  执行次数
        //cc.repeat(action,times);
        console.log('on-repeat');
        this.node.runAction(cc.repeat(cc.rotateBy(1, 90), 5)); //旋转5个90度
    },

    'on-repeatForever': function onRepeatForever() {
        //无限重复动画
        //参数一 action 需要执行的动画
        //cc.repeatForever(action)
        console.log('on-repeatForever');
        this.node.runAction(cc.repeatForever(cc.rotateBy(1, 180)));
    },

    'on-spawn': function onSpawn() {
        //并行动画
        //参数一 tempArray 需要同时执行的一组动画
        var action1 = cc.rotateBy(1, 90);
        var action2 = cc.scaleTo(1, 1.5);
        //可以单独传
        //this.node.runAction(cc.spawn(action1,action2));
        //也可以扔一个数组
        //cc.spawn(tempArray);
        console.log('on-spawn');
        var actionsArray = [action1, action2];
        this.node.runAction(cc.spawn(actionsArray));
    },

    'on-rotateTo': function onRotateTo() {
        //绝对旋转
        //参数一 duration 持续时间
        //参数二 deltaAngleX X方向旋转角度
        //tips: 旋转角度计算规律 最终角度angle为 angle = inputAngle%360>180?inputAngle%360-180:inputAngle%360
        //参数三 [deltaAngleY ] Y方向旋转角度 没用过，大家可以试下
        //cc.rotateTo(duration,deltaAngleX,[deltaAngleY ]);
        console.log('on-rotateTo');
        this.node.runAction(cc.rotateTo(1, 180)); //一秒转到180度
    },

    'on-rotateBy': function onRotateBy() {
        //相对旋转
        //参数一 duration 持续时间
        //参数二 deltaAngleX X方向旋转角度 好像是顺时针
        //参数三 [deltaAngleY ] Y方向旋转角度 没用过，大家可以试下
        //cc.rotateBy(duration,deltaAngleX,[deltaAngleY ]);
        console.log('on-rotateBy');
        this.node.runAction(cc.rotateBy(1, 90)); //一秒内加转90度
    },

    'on-moveTo': function onMoveTo() {
        //绝对移动
        //参数一 duration 持续时间
        //参数二 position cc.Vec2()类型 绝对目标位置
        //参数三 [y ] 绝对目标位置y值
        //解释 也就是说可以用下面两种方式
        //cc.moveTo(duration,position,[y ])
        //this.node.runAction(cc.moveTo(cc.v2(150,150)));
        console.log('on-moveTo');
        this.node.runAction(cc.moveTo(1, 50, 50)); //一秒内移到(50px,50px)的位置
    },

    'on-moveBy': function onMoveBy() {
        //相对移动
        //参数一 duration 持续时间
        //参数二 position cc.Vec2()类型 相对目标位置
        //参数三 [y ] 相对目标位置y值
        //解释 也就是说可以用下面两种方式
        //cc.moveBy(duration,position,[y ])
        //this.node.runAction(cc.moveBy(cc.v2(150,150)));
        console.log('on-moveBy');
        this.node.runAction(cc.moveBy(1, 150, 150)); //一秒内移到以当前位置Wie参考点加(150px,150px)的位置
    }

});
//还有一部分没更完，我逐步push上来吧

cc._RFpop();
},{}],"A-script-sys":[function(require,module,exports){
cc._RFpush(module, 'ccf2ahrO29AX6lYvr+Qd+Vx', 'A-script-sys');
// sys-on-emit\A-script-sys.js

'use strict';

cc.Class({
    'extends': cc.Component,

    properties: {
        eventPanel: {
            'default': null,
            type: cc.Label
        }
    },

    onLoad: function onLoad() {
        //事件机制说明：
        //一句话,事件机制可以解决这种需求：某个条件达成才做某事
        //参数一：eventName 事件名 用于区别监听的事件类型
        //参数二: callback 回调函数 当事件名所描述的条件发生时，触发该函数
        //参数三：target 调用者， 指定调用该回调函数的调用者,通常是回调函数所处的这个对象(this),也可以动态指定别的对象来调用回调函数。
        //node.on('eventName',callback,target);

        //鼠标事件回调函数callback
        //参数一 event 事件触发时的现场信息
        //event.getDelta();  返回和上一次触发时鼠标位置的差值 返回值类型: cc.Vec2();  可以通过event.getDelta().x,event.getDelta().y获取
        //event.getDeltaX(); 返回和上一次触发时鼠标位置在X方向上的差值 返回值类型 Number 和上面一样
        //event.getDeltaY(); 返回和上一次触发时鼠标位置在Y方向上的差值 返回值类型 Number 和上面一样
        //event.getLocation(); 返回以当前节点的锚点为坐标原点的鼠标坐标 返回值类型: cc.Vec2(); 可以通过event.getLocation().x,event.getLocation().y获取
        //event.getLocationX(); 返回以当前节点的锚点为坐标原点在X方向上的鼠标坐标 返回值类型 Number 和上面一样
        //event.getLocationY(); 返回以当前节点的锚点为坐标原点在Y方向上的鼠标坐标 返回值类型 Number 和上面一样
        //event.getLocationInView(); 返回以手机屏幕左上(左下？)为坐标原点的鼠标坐标 返回值类型 cc.Vec2(); 可以通过event.getLocationInView().x,event.getLocationInView().y获取
        //event.getScrollX(); 用于'mousewheel'事件 获取鼠标滚轮滚动X差值？鼠标滚轮只能上下滚，也不知道这个怎么用 默认为0
        //event.getScrollY(); 用于'mousewheel'事件 获取鼠标滚轮滚动Y差值？我的鼠标上滚动值为120,下滚动值为-120

        var showEventInfo = (function (event) {
            var type = event.type;
            var delta = event.getDelta();
            var deltaX = event.getDeltaX();
            var deltaY = event.getDeltaY();
            var location = event.getLocation();
            var locationX = event.getLocationX();
            var locationY = event.getLocationY();
            var locationInView = event.getLocationInView();
            var scrollX = event.getScrollX();
            var scrollY = event.getScrollY();

            var msg = 'event.type: ' + type + '\n' + 'event.getDelta().x: ' + delta.x + '\n' + 'event.getDelta().y: ' + delta.y + '\n' + 'event.getDeltaX(): ' + deltaX + '\n' + 'event.getDeltaY(): ' + deltaY + '\n' + 'event.getLocation().x: ' + location.x + '\n' + 'event.getLocation().y: ' + location.y + '\n' + 'event.getLocationX(): ' + locationX + '\n' + 'event.getLocationY(): ' + locationY + '\n' + 'event.getLocationInView().x: ' + locationInView.x + '\n' + 'event.getLocationInView().y: ' + locationInView.y + '\n' + 'event.getScrollX(): ' + scrollX + '\n' + 'event.getScrollY(): ' + scrollY + '\n';

            this.eventPanel.string = msg;
        }).bind(this);

        //鼠标类型事件
        //'mousedown'  当鼠标按下时触发一次
        this.node.on('mousedown', function (event) {
            this.node.runAction(cc.scaleTo(0.1, 0.8)); //尺寸缩小为原来80%
            showEventInfo(event);
        }, this);

        //'mouseenter' 当鼠标移入目标节点区域时触发，不论是否按下
        this.node.on('mouseenter', function (event) {
            this.node.runAction(cc.rotateTo(0.1, 180)); //旋转180度
            showEventInfo(event);
        }, this);

        //'mousemove'  当鼠标在目标节点在目标节点区域中移动时触发，不论是否按下
        this.node.on('mousemove', function (event) {
            //this.node.runAction(cc.rotateBy(0.1,30));//旋转30度
            //showEventInfo(event);
            //move触发太快，这里就不演示了
        }, this);

        //'mouseleave' 当鼠标移出目标节点区域时触发，不论是否按下
        this.node.on('mouseleave', function (event) {
            this.node.runAction(cc.rotateTo(0.1, 0)); //旋转180度复原
            showEventInfo(event);
        }, this);

        //'mouseup'	   当鼠标从按下状态松开时触发一次
        this.node.on('mouseup', function (event) {
            this.node.runAction(cc.scaleTo(0.1, 1)); //尺寸放大为100%
            showEventInfo(event);
        }, this);

        //'mousewheel'	当鼠标滚轮滚动时触发
        this.node.on('mousewheel', function (event) {
            this.node.runAction(cc.scaleTo(0.1, event.getScrollY() / 120)); //获取滚动值来设置大小
            showEventInfo(event);
        }, this);
    }

});

cc._RFpop();
},{}],"B-script-sys":[function(require,module,exports){
cc._RFpush(module, 'de557yg42VJBYuqRWx8XEZl', 'B-script-sys');
// sys-on-emit\B-script-sys.js

'use strict';

cc.Class({
    'extends': cc.Component,

    properties: {
        eventPanel: {
            'default': null,
            type: cc.Label
        }
    },

    onLoad: function onLoad() {
        //事件机制说明：
        //一句话,事件机制可以解决这种需求：某个条件达成才做某事
        //参数一：eventName 事件名 用于区别监听的事件类型
        //参数二: callback 回调函数 当事件名所描述的条件发生时，触发该函数
        //参数三：target 调用者， 指定调用该回调函数的调用者,通常是回调函数所处的这个对象(this),也可以动态指定别的对象来调用回调函数。
        //node.on('eventName',callback,target);

        //触摸事件回调函数callback
        //参数一 event 事件触发时的现场信息
        //=。=说不清楚，看demo-online吧

        var showEventInfo = (function (event) {
            var type = event.type;
            var delta = event.touch.getDelta();
            var location = event.touch.getLocation();
            var locationX = event.touch.getLocationX();
            var locationY = event.touch.getLocationY();
            var locationInView = event.touch.getLocationInView();
            var previousLocation = event.touch.getPreviousLocation();
            var previousLocationInView = event.touch.getPreviousLocationInView();
            var startLocation = event.touch.getStartLocation();
            var startLocationInView = event.touch.getStartLocationInView();

            var msg = 'event.type: ' + type + '\n' + 'event.touch.getDelta().x: ' + delta.x + '\n' + 'event.touch.getDelta().y: ' + delta.y + '\n' + 'event.touch.getLocation().x: ' + location.x + '\n' + 'event.touch.getLocation().y: ' + location.y + '\n' + 'event.touch.getLocationX(): ' + locationX + '\n' + 'event.touch.getLocationY(): ' + locationY + '\n' + 'event.touch.getLocationInView().x: ' + locationInView.x + '\n' + 'event.touch.getLocationInView().y: ' + locationInView.y + '\n' + 'event.touch.getPreviousLocation().x: ' + previousLocation.x + '\n' + 'event.touch.getPreviousLocation().y: ' + previousLocation.y + '\n' + 'event.touch.getPreviousLocationInView().x: ' + previousLocationInView.x + '\n' + 'event.touch.getPreviousLocationInView().y: ' + previousLocationInView.y + '\n' + 'event.touch.getStartLocation().x: ' + startLocation.x + '\n' + 'event.touch.getStartLocation().y: ' + startLocation.y + '\n' + 'event.touch.getStartLocationInView().x: ' + startLocationInView.x + '\n' + 'event.touch.getStartLocationInView().y: ' + startLocationInView.y + '\n';

            this.eventPanel.string = msg;
        }).bind(this);

        //触摸类型事件
        //'touchstart'	当手指触摸到屏幕时
        this.node.on('touchstart', function (event) {
            this.node.runAction(cc.rotateTo(0.1, 180)); //旋转180度
            this.node.runAction(cc.scaleTo(0.1, 0.8)); //尺寸缩小为原来80%
            showEventInfo(event);
        }, this);

        //'touchmove'	当手指在屏幕上目标节点区域内移动时
        this.node.on('touchmove', function (event) {
            showEventInfo(event);
        }, this);

        //'touchend'	当手指在目标节点区域内离开屏幕时
        this.node.on('touchend', function (event) {
            this.node.runAction(cc.rotateTo(0.1, 0)); //旋转180度复原
            this.node.runAction(cc.scaleTo(0.1, 1)); //尺寸放大为100%
            showEventInfo(event);
        }, this);

        //'touchcancel'	当手指在目标节点区域外离开屏幕时
        this.node.on('touchcancel', function (event) {
            this.node.runAction(cc.rotateTo(0.1, 0)); //旋转180度复原
            this.node.runAction(cc.scaleTo(0.1, 1)); //尺寸放大为100%
            showEventInfo(event);
        }, this);
    }

});

cc._RFpop();
},{}],"canvas-script":[function(require,module,exports){
cc._RFpush(module, 'c36a4J14gBFhay4yN9LmcH8', 'canvas-script');
// global\canvas-script.js

"use strict";

cc.Class({
    "extends": cc.Component,

    properties: {
        // foo: {
        //    default: null,
        //    url: cc.Texture2D,  // optional, default is typeof default
        //    serializable: true, // optional, default is true
        //    visible: true,      // optional, default is true
        //    displayName: 'Foo', // optional
        //    readonly: false,    // optional, default is false
        // },
        // ...
    },

    // use this for initialization
    onLoad: function onLoad() {
        this.node.runAction(cc.rotateTo(1, 0).easing(cc.easeElasticInOut(1.0)));
        this.node.runAction(cc.scaleTo(1, 1, 1).easing(cc.easeElasticInOut(1.0)));
    }

});
// called every frame, uncomment this function to activate update callback
// update: function (dt) {

// },

cc._RFpop();
},{}],"to-other-scene":[function(require,module,exports){
cc._RFpush(module, 'd105f2t5TVJErXufGojomqu', 'to-other-scene');
// global\to-other-scene.js

'use strict';

cc.Class({
    'extends': cc.Component,

    properties: {
        // foo: {
        //    default: null,
        //    url: cc.Texture2D,  // optional, default is typeof default
        //    serializable: true, // optional, default is true
        //    visible: true,      // optional, default is true
        //    displayName: 'Foo', // optional
        //    readonly: false,    // optional, default is false
        // },
        // ...
    },

    // use this for initialization
    onLoad: function onLoad() {},

    sceneTransform: function sceneTransform() {
        var canvas = cc.find('Canvas');
        canvas.runAction(cc.rotateTo(1, 180).easing(cc.easeElasticInOut(1.0)));
        canvas.runAction(cc.scaleTo(1, -1, 0).easing(cc.easeElasticInOut(1.0)));
    },

    'to-simple-scene': function toSimpleScene() {
        this.sceneTransform();
        setTimeout(function () {
            cc.director.loadScene('simple-action');
        }, 1000);
    },

    'to-easing-scene': function toEasingScene() {
        this.sceneTransform();
        setTimeout(function () {
            cc.director.loadScene('easing-action');
        }, 1000);
    },

    'to-sys-scene': function toSysScene() {
        this.sceneTransform();
        setTimeout(function () {
            cc.director.loadScene('sys-on-emit');
        }, 1000);
    },

    'to-cus-scene': function toCusScene() {
        this.sceneTransform();
        setTimeout(function () {
            cc.director.loadScene('cus-on-emit');
        }, 1000);
    }

});
// called every frame, uncomment this function to activate update callback
// update: function (dt) {

// },

cc._RFpop();
},{}]},{},["A-script-simple","8-script-cus","canvas-script","A-script-sys","to-other-scene","B-script-sys","A-script-easing"]);
